import { createContext } from 'react';
/**
 * Citrus theme provider
 *
 * @type React.Context
 * @example
 * <CitrusUser.Provider value={{ name: 'citrus2022' }}>
 *   <div>Your App Goes Here</div>
 * </CitrusUser.Provider>
 */
export var CitrusTheme = createContext(null);
